export default "__VITE_ASSET__850f169d__"